module.exports = __webpack_public_path__ + "img/footer1.d843da56.png";